import RMSOnboardingLayoutContainer from "./RMSOnboardingLayoutContainer";
import RMSOnboardingLayoutStore from "./RMSOnboardingLayoutStore";

export default RMSOnboardingLayoutStore(RMSOnboardingLayoutContainer);